import type { ReactNode } from 'react';

export const symbol_nest_heat_link_e: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M324-111.5Q251-143 197-197t-85.5-127Q80-397 80-480t31.5-156Q143-709 197-763t127-85.5Q397-880 480-880t156 31.5Q709-817 763-763t85.5 127Q880-563 880-480t-31.5 156Q817-251 763-197t-127 85.5Q563-80 480-80t-156-31.5ZM479.78-140Q621-140 720.5-239.28t99.5-240.5Q820-621 720.72-720.5T480.22-820Q339-820 239.5-720.72T140-480.22Q140-339 239.28-239.5t240.5 99.5ZM381-381.18q-41-41.17-41-99Q340-538 381.18-579q41.17-41 99-41Q538-620 579-578.82q41 41.17 41 99Q620-422 578.82-381q-41.17 41-99 41Q422-340 381-381.18Z"
		/>
	</svg>
);
